import { render } from "./UnsubmittedRequests.vue?vue&type=template&id=04c99a94"
import script from "./UnsubmittedRequests.vue?vue&type=script&lang=js"
export * from "./UnsubmittedRequests.vue?vue&type=script&lang=js"

import "./UnsubmittedRequests.vue?vue&type=style&index=0&id=04c99a94&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__